//MODEL: nothing

define('app/nav/PasswordChange',['require','glu/itemView','config','glu/http','glu/dialog','app/store','hbs!./PasswordChange.hbs'],function(require) {
	'use strict';


	var ItemView = require('glu/itemView');
	var config = require('config');
	var http = require('glu/http');
	var Dialog = require('glu/dialog');
	var sessionStore = require('app/store');

	var view = ItemView.extend({

		template: require('hbs!./PasswordChange.hbs'),

		dialogTitle: 'Change Password',

		getClass: function() {
			return 'modal-change-password';
		},

		ui: {
			$passwordOld: '#passwd-form-password-old',
			$passwordNew1: '#passwd-form-password-new1',
			$passwordNew2: '#passwd-form-password-new2'
		},

		dialogButtons: [{
			text: 'Ok',
			callback: 'okCallback',
			className: 'btn-primary'
		}, {
			text: 'Cancel',
			callback: 'cancelCallback',
			className: 'btn-primary'
		}],

		onRender: function() {},

		getuiOldPassword: function() {
			return this.ui.$passwordOld.val().trim();
		},

		getuiNewPassword1: function() {
			return this.ui.$passwordNew1.val().trim();
		},

		getuiNewPassword2: function() {
			return this.ui.$passwordNew2.val().trim();
		},

		okCallback: function() {
			var pOld = this.getuiOldPassword();
			var pNew1 = this.getuiNewPassword1();
			var pNew2 = this.getuiNewPassword2();

			//clear border colors (old errors)
			this.ui.$passwordOld.removeClass('passwd-dialog-item-error');
			this.ui.$passwordNew1.removeClass('passwd-dialog-item-error');
			this.ui.$passwordNew2.removeClass('passwd-dialog-item-error');

			//verify none of the fields is blank and new password strings match
			var err = false;
			if (pOld.length === 0) {
				this.ui.$passwordOld.addClass('passwd-dialog-item-error');
				err = true;
			}
			if (pNew1.length === 0) {
				this.ui.$passwordNew1.addClass('passwd-dialog-item-error');
				err = true;
			}
			if (pNew2.length === 0) {
				this.ui.$passwordNew2.addClass('passwd-dialog-item-error');
				err = true;
			}
			if (pNew1 !== pNew2) { //verify pNew1 == pNew2
				this.ui.$passwordNew1.addClass('passwd-dialog-item-error');
				this.ui.$passwordNew2.addClass('passwd-dialog-item-error');
				err = true;
			}
			if (!this.validatePassword(pNew1)) {
				this.ui.$passwordNew1.addClass('passwd-dialog-item-error');
				this.ui.$passwordNew2.addClass('passwd-dialog-item-error');
				err = true;
			}

			if (err) {
				return;
			}

			var data = {
				passwordOld: pOld,
				passwordNew: pNew1
			};

			http.post(config.apiRoot + 'auth/passwd', data).then(function(results) {
				sessionStore.setApiToken(results);
			}, function() {
				Dialog.alert(
					'We were unable to change your password. Please make sure you have correctly filled out all fields, and try again. If you continue to have issues, please contact customer support.',
					'Unable to update password'
				);
			});
			Dialog.close();
		},

		cancelCallback: function() {
			Dialog.close();
		},

		serializeData: function() {
			return this;
		},

		validatePassword: function(password) {
			var errors = [];

			if (password.length < 8) {
				errors.push('Your password must be at least 8 characters');
			}
			if (password.length > 160) {
				errors.push('Your password must be at most 160 characters');
			}
			if (password.search(/[a-z]/) < 0) {
				errors.push('Your password must contain at least one letter.');
			}
			if (password.search(/[0-9]/) < 0) {
				errors.push('Your password must contain at least one digit.');
			}
			if (password.search(/[A-Z]/) < 0) {
				errors.push('Your password must contain at least one upper case letter.');
			}
			if (password.search(/[!@#$%^&*?]/) < 0) {
				errors.push('Your password must contain at least one special character from [!@#$%^&*?].');
			}
			if (errors.length > 0) {
				return false;
			}
			return true;
		}

	});

	return view;
});

